import React, { useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Sidebar } from 'primereact/sidebar'

import { AuthenticationContext } from '../../../Auth/authentication.context'

import NotificationDropdown from './NotificationDropdown'
import ProfileMenu from './ProfileMenu'

import logodarkImg from '../../../assets/images/logo-dark.png'
import logosmImg from '../../../assets/images/logo-sm.png'
import logolightImg from '../../../assets/images/logo-light.png'
import paLogo from '../../../assets/images/oscolored.png'
import ManagementLogo from '../../../assets/images/Origins_Management.png'
import DirectLogo from '../../../assets/images/Origins_Direct.png'
import logoSign from '../../../assets/images/sign.png'
import { Button } from 'primereact/button'
import PrimeSidebar from '../Sidebar/Prime/PrimeSidebar'
import Systems from './Systems'
import { Tooltip } from 'primereact/tooltip'
import originsManganegment from '../../../assets/images/ORIGINS-MANAGEMENT.png'
import originsDirect from '../../../assets/images/ORIGINS-DIRECT.png'
import originsDirectInstant from '../../../assets/images/ORIGINS-DIRECT-INSTANT.png'
import openRxLogoPng from '../../../assets/images/open-rx-logo-png.png'
import { useBranding } from '../../../contexts/BrandingContext'
import Modals from '../../shared/Modals'
const Header = (props) => {
  const { onLogout, setCollapsed, isAdmin, user, module, setModule } = useContext(
    AuthenticationContext
  )
  const { isGroupMode, logo, favicon, displayName } = useBranding()
  const [visible, setVisible] = useState(false)
  const [userModule, setUserModule] = useState('')
  const [infoModalVisible, setInfoModalVisible] = useState(false)

  useEffect(() => {
    if (module) {
      setUserModule(module)
    }
  }, [module])

  // Set module to Origins Direct for pharmacy users when Systems component is not rendered
  useEffect(() => {
    if (user?.role === 'pharmacy' && !isGroupMode) {
      const moduleFromLocalStorage = localStorage.getItem('module')
      if (moduleFromLocalStorage) {
        setModule(moduleFromLocalStorage)
      } else if (user?.pharmacyModules) {
        const originsDirectModule = user.pharmacyModules.find(
          (m) => m.name === 'Origins Direct'
        )
        const originsDirectInstanceModule = user.pharmacyModules.find(
          (m) => m.name === 'Origins Direct Instant'
        )
        if (originsDirectModule) {
          setModule(originsDirectModule.name)
          localStorage.setItem('module', originsDirectModule.name)
        } else if (originsDirectInstanceModule) {
          setModule(originsDirectInstanceModule.name)
          localStorage.setItem('module', originsDirectInstanceModule.name)
        } else if (user.pharmacyModules.length > 0) {
          setModule(user.pharmacyModules[0].name)
          localStorage.setItem('module', user.pharmacyModules[0].name)
        }
      }
    }
  }, [user, isGroupMode, setModule])

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 992) {
      body.classList.toggle('sidebar-enable')
    } else {
      setCollapsed((prevState) => !prevState)
      body.classList.toggle('vertical-collpsed')
      body.classList.toggle('sidebar-enable')
    }
  }

  const navigate = useNavigate()

  return (
    <React.Fragment>
      <header id='page-topbar'>
        <div className='navbar-header'>
          <PrimeSidebar visible={visible} setVisible={setVisible} />

          <div className='d-flex'>
            <div
              className='navbar-brand-box'
              style={!isGroupMode ? { backgroundColor: '#ececf1' } : undefined}
            >
              <Link to={isAdmin ? 'admin' : '/'} className='logo logo-dark'>
                <span className='logo-sm'>
                  <img
                    src={isGroupMode && (favicon || logo) ? (favicon || logo) : logoSign}
                    alt=''
                    height='50'
                    width='50'
                  />
                </span>
                <span className='logo-lg'>
                  {user?.role !== 'pharmacy' ? (
                    <img src={paLogo} alt='Origins Systems' height='15' />
                  ) : userModule === 'Origins Direct' ? (
                    <img
                      src={originsDirect}
                      alt='Origins Direct'
                      height='30'
                    />
                  ) : userModule === 'Origins Management' ? (
                    <img
                      src={isGroupMode ? (logo || openRxLogoPng) : originsManganegment}
                      alt={isGroupMode ? displayName : 'Origins Management'}
                      height='30'
                    />
                  ) : /* userModule === 'Origins Direct Instant' ? (
                    <img
                      src={originsDirectInstant}
                      style={{ marginLeft: '40px' }}
                      alt='Origins Direct Instant'
                      height='30'
                    />
                  ) : */ null}
                </span>
              </Link>

              <Link to='/' className='logo logo-light'>
                <span className='logo-sm'>
                  <img
                    src={isGroupMode && (favicon || logo) ? (favicon || logo) : logoSign}
                    alt=''
                    height='22'
                  />
                </span>
                <span className='logo-lg'>
                  {isGroupMode ? (
                    <img
                      src={logo || openRxLogoPng}
                      alt={displayName}
                      height='30'
                    />
                  ) : user?.role !== 'pharmacy' ? (
                    <img src={paLogo} alt='Origins Systems' height='30' />
                  ) : userModule === 'Origins Direct' ? (
                    <img src={originsDirect} alt='Origins Direct' height='30' />
                  ) : userModule === 'Origins Management' ? (
                    <img src={originsManganegment} alt='Origins Management' height='30' />
                  ) : (
                    <img src={paLogo} alt='Origins Systems' height='30' />
                  )}
                </span>
              </Link>
            </div>

            <button
              type='button'
              className='btn header-item noti-icon waves-effect'
              id='vertical-menu-btn'
              onClick={() => {
                tToggle()
              }}
              data-target='#topnav-menu-content'
            >
              <i className='mdi mdi-menu'></i>
            </button>
          </div>

          <div className='d-flex justify-content-end align-items-center gap-2'>
            {/* {user?.role === 'pharmacy' && !isGroupMode && <Systems />} */}

            {/* <div className='dropdown d-none d-lg-inline-block '>
              <button
                type='button'
                onClick={() => {
                  toggleFullscreen()
                }}
                className='btn header-item noti-icon waves-effect '
              >
                <Tooltip
                  target='.fullscreen'
                  content={`fullscreen`}
                  tooltipOptions={{ position: 'bottom' }}
                  position='bottom'
                />

                <i className='mdi mdi-fullscreen fullscreen'></i>
              </button>
            </div> */}
            {/* {!isGroupMode && (
              <div className='dropdown d-none d-lg-inline-block'>
                <button
                  type='button'
                  onClick={() => {
                    setInfoModalVisible(true)
                  }}
                  className='btn header-item noti-icon waves-effect'
                >
                  <Tooltip
                    target='.info-icon'
                    content='Systems Information'
                    tooltipOptions={{ position: 'bottom' }}
                    position='bottom'
                  />
                  <i className='mdi mdi-information-outline info-icon'></i>
                </button>
              </div>
            )} */}

            <Modals
              ModalHeader='Available Systems'
              visible={infoModalVisible}
              setVisible={setInfoModalVisible}
              btnName='Close'
              onButtonClick={() => { }}
              width='50rem'
              hideMainButton={true}
            >
              <div className='row'>
                {/* First option */}
                <div className='col-md-4 mb-3'>
                  <div
                    className='system-option p-3 text-center h-100'
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <div className='mb-3'>
                      <div
                        className='system-logo d-flex align-items-center flex-column justify-content-center'
                        style={{
                          height: '100px',
                          width: '100px',
                          margin: '0 auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i
                          className='mdi mdi-credit-card text-success'
                          style={{ fontSize: '50px' }}
                        ></i>
                        <div className=''>
                          <img
                            src={originsDirectInstant}
                            alt='Origins Instant'
                            style={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    </div>
                    <p className='small text-muted'>
                      Origins Direct-Instant is an extension of Origins Direct
                      that facilitates the financial aspect of medication
                      procurement from pharmaceutical manufacturers by retail
                      pharmacies. It allows retail pharmacies to drive growth
                      and increase profitability, while also improving cashflow
                      for manufacturers.
                    </p>
                  </div>
                </div>

                {/* Second option - same pattern */}
                <div className='col-md-4 mb-3'>
                  <div
                    className='system-option p-3 text-center h-100'
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <div className='mb-3'>
                      <div
                        className='system-logo d-flex align-items-center flex-column justify-content-center'
                        style={{
                          height: '100px',
                          width: '100px',
                          margin: '0 auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i
                          className='mdi mdi-shopping text-primary'
                          style={{ fontSize: '50px' }}
                        ></i>
                        <div className='system-logo-img'>
                          <img
                            src={originsDirect}
                            alt='Origins Direct'
                            style={{ width: '60%' }}
                          />
                        </div>
                      </div>
                    </div>
                    <p className='small text-muted'>
                      Origins Direct is a platform that connects retail
                      pharmacies with pharmaceutical manufacturers directly,
                      creating an essential link that combines the desires of
                      the manufacturer for effective distribution of their
                      products with the needs of the retail pharmacies for a
                      steady, reliable source of a variety of products.
                    </p>
                  </div>
                </div>

                {/* Third option - same pattern */}
                <div className='col-md-4 mb-3'>
                  <div
                    className='system-option p-3 text-center h-100'
                    style={{
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                    }}
                  >
                    <div className='mb-3'>
                      <div
                        className='system-logo d-flex align-items-center flex-column justify-content-center'
                        style={{
                          height: '100px',
                          width: '100px',
                          margin: '0 auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <i
                          className='mdi mdi-chart-line text-warning'
                          style={{ fontSize: '50px' }}
                        ></i>
                        <div className='system-logo-img w-100'>
                          <img
                            src={originsManganegment}
                            alt='Origins Management'
                            style={{ width: '100%' }}
                          />
                        </div>
                      </div>
                    </div>
                    <p className='small text-muted'>
                      ORIGINS MANAGEMENT is a management tool that facilitates
                      the transactional aspect of the relationship between
                      suppliers and retail pharmacies. If offers day-to-day
                      financial tracking with a high level of transparency in
                      order to simplify the numbers to retail pharmacies in real
                      time and offer piece of mind.
                    </p>
                  </div>
                </div>
              </div>
            </Modals>
            {user && (
              <div className='header-user-info-card'>
                <div className='header-user-info-content'>
                  {user.role === 'pharmacy' ? (
                    <>
                      <div className='header-user-info-name' title={user.pharmacyName}>
                        {user.pharmacyName}
                      </div>
                      <div className='header-user-info-role'>
                        Account No: {user.accountNo}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='header-user-info-name' title={user.email}>
                        {user.displayName || user.email}
                      </div>
                      <div className='header-user-info-role'>
                        {user.role?.charAt(0).toUpperCase() + user.role?.slice(1)}
                      </div>
                    </>
                  )}
                </div>
                <button
                  type='button'
                  onClick={onLogout}
                  className='header-user-info-logout-btn'
                  title='Logout'
                  aria-label='Logout'
                >
                  <i className='mdi mdi-logout'></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header
